import React from 'react';
import { motion } from 'framer-motion';
import Banner_1 from './Content_Assets/WhatsApp Image 2025-03-11 at 21.06.46.jpeg';
import Banner_2 from './Content_Assets/WhatsApp Image 2025-03-11 at 21.06.47.jpeg';


function Banners() {
  return (
    <div className='banners_inner' style={{ display: 'flex', overflow: 'hidden' }}>
      <motion.div
        className='banner_inner_image'
        initial={{ x: '-100%' }}
        animate={{ x: '0%' }}
        transition={{ duration: 2, repeat: Infinity, repeatType: 'reverse' }}
      >
        <img src={Banner_1} />
      </motion.div>

      <motion.div
        className='banner_inner_image'
        initial={{ x: '-100%' }}
        animate={{ x: '0%' }}
        transition={{ duration: 2, repeat: Infinity, repeatType: 'reverse', delay: 1 }}
      >
        <img src={Banner_2} />
      </motion.div>


    </div>
  );
}

export default Banners;
